<template>
    <div>
        <table-actions-menu
            v-if="!this.showDeleted"
        >
            <edit-button :url="route('main.managers.show', data.id)"></edit-button>

            <async-table-action-button :callback="resetPassword" :label="trans('buttons.password_reset')">
                <inline-svg
                    :url="require('../../../../images/actions/password.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </async-table-action-button>

            <async-table-action-button :callback="toggleStatus" :noPremadeMode="true">
                <div class="table-action-cell__icon-wrapper">
                    <inline-svg
                        :url="require('../../../../images/actions/lock.svg')"
                        classes="table-action-cell__icon"
                        v-if="isActive"
                    >
                    </inline-svg>

                    <inline-svg
                        :url="require('../../../../images/actions/unlock.svg')"
                        classes="table-action-cell__icon"
                        v-if="!isActive"
                    >
                    </inline-svg>
                </div>
                <div class="table-action-cell__label" v-if="isActive">{{trans('buttons.lock')}}</div>
                <div class="table-action-cell__label" v-if="!isActive">{{trans('buttons.unlock')}}</div>
            </async-table-action-button>



            <delete-button
                :url="route('mainapi.managers.destroy', data.id)"
                :confirmTitle="this.trans('managers.note.delete_title')"
                :confirmText="this.trans('managers.note.delete_message')"
                :errorFlashMessage="this.trans('managers.flash.not_deleted')"
                :deleteId="data.id"
            ></delete-button>
        </table-actions-menu>

        <table-actions-menu v-if="this.showDeleted"
                :position="'table-action-menu--low'">
            <div class="table-action-cell">
                <button @click.prevent="restoreUser">
                    <div class="table-action-cell__icon-wrapper">
                        <svg class="table-action-cell__icon" width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M9.81649 12.1286C12.4772 12.1286 14.6377 9.54285 14.6377 6.35714C14.6377 3.17142 13.9272 0.585709 9.81649 0.585709C5.70574 0.585709 4.99524 3.17857 4.99524 6.36428C4.99524 9.55 7.15574 12.1286 9.81649 12.1286Z"/>
                                <path d="M12.5424 18.3786C12.5424 16.3 13.4704 14.4357 14.9422 13.1571C14.2462 12.9357 13.4197 12.7429 12.4554 12.5714C12.4554 12.5714 11.6652 13.5643 9.81645 13.5643C7.9677 13.5714 7.17745 12.5714 7.17745 12.5714C1.60945 13.5643 0.826449 15.1214 0.724949 20.5214C0.717699 20.9643 0.710449 20.9857 0.710449 20.9357C0.710449 21.0286 0.710449 21.2071 0.710449 21.5214C0.710449 21.5214 2.0517 24.1857 9.81645 24.1857C12.0277 24.1857 13.7169 23.9714 15.0074 23.6571C13.4994 22.3786 12.5424 20.4857 12.5424 18.3786Z" />
                                <path d="M15.4208 18.3786C15.4208 20.75 17.3783 22.6786 19.7853 22.6786C22.1923 22.6786 24.1498 20.75 24.1498 18.3786H21.2426L25.1213 13.6L29.0001 18.3786H26.0928C26.0928 21.8 23.2653 24.5857 19.7926 24.5857C16.3198 24.5857 13.4923 21.8 13.4923 18.3786C13.4923 14.9571 16.3198 12.1714 19.7926 12.1714V14.0786C17.3783 14.0786 15.4208 16.0071 15.4208 18.3786Z" />
                                </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="29" height="25"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="table-action-cell__label">{{trans('buttons.restore')}}</div>
                </button>
            </div>
        </table-actions-menu>
    </div>
</template>

<script>
    import { EventBus } from '../../eventbus';
    import TableActionsMenu from '../../table_actions/TableActionsMenu.vue';
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';
    import InlineSvg from '../../../util/inlineSvg.js'
    import ModalResetPassword from '../../users/ResetPassword.vue';

    export default {
        props: ['data', 'index', 'column'],

        components: {
            TableActionsMenu,
            EditButton,
            DeleteButton,
            InlineSvg
        },

        data() {
            return {
                roleUrl:'#',
                isActive: this.data.is_active,
                showDeleted: false
            }
        },

        computed: {

        },

        mounted() {
            EventBus.$on('onChangeAction', show => this.showDeleted = show);
        },

        methods: {
            resetPassword() {
                this.$modal.show(ModalResetPassword, {
                        user_id: this.data.id,
                        last_login: this.data.last_login
                    },
                    {
                        height: 'auto',
                        adaptive: true,
                        pivotY: 0.3,
                        scrollable: true,
                    }
                );
            },

            /**
            * Displays modal with two options: Reset password and welcome mail
            */
            toggleStatus() {
                this.$alertify.confirmWithTitle(
                    this.data.is_active ? this.trans('managers.note.deactivate_user') : this.trans('managers.note.activate_user'),
                    this.data.is_active ? this.trans('managers.note.deactivate_message') : this.trans('managers.note.activate_message'),
                    () => {
                    axios
                        .get(this.route('mainapi.managers.status.toggle', this.data.id))
                        .then(response => {
                            if (response.data.success) {
                                this.isActive = !this.isActive
                                this.data.is_active =!this.data.is_active;
                            }
                            this.flash(response);
                        })
                        .catch(() => {
                            this.flash({message: this.trans('managers.flash.not_executed'), level: 'warning'});
                        });
                    }
                );
            },

            restoreUser() {
                this.$alertify.confirmWithTitle(
                    this.trans('managers.note.restore_user'),
                    this.trans('managers.note.restore_message'),
                    () => {
                    axios
                        .get(this.route('mainapi.managers.restore', this.data.id))
                        .then(response => {
                            EventBus.$emit('onRestoreUser', this.index-1);

                            this.flash(response);
                        })
                        .catch(() => {
                            this.flash({message: this.trans('managers.flash.not_executed'), level: 'warning'});
                        });
                    }
                );
            },
        }
    }
</script>
